/* Clean Slate — theme scripts (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: {}, strings: {} };

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncement() {
    $$('.announcement').forEach(function (bar) {
      var msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2) return;
      var i = 0;
      var secs = parseInt(bar.dataset.rotate, 10) || 5;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, secs * 1000);
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero() {
    $$('[data-slideshow]').forEach(function (hero) {
      var slides = $$('.hero__slide', hero);
      var dots = $$('.hero__dot', hero);
      if (slides.length < 2) return;
      var current = 0;
      var timer;
      function go(n) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (n + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }
      function start() {
        var secs = parseInt(hero.dataset.autoplay, 10);
        if (!secs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        clearInterval(timer);
        timer = setInterval(function () { go(current + 1); }, secs * 1000);
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.dataset.slideTo, 10)); start(); });
      });
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------- Header: drawer + search ---------- */
  function initHeader() {
    var header = $('[data-header]');
    var drawer = $('.js-drawer');
    var search = $('.js-search');
    function setDrawerTop() {
      if (!header) return;
      var rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--drawer-top', Math.max(rect.bottom, 0) + 'px');
    }
    if (drawer) {
      drawer.addEventListener('toggle', function () {
        setDrawerTop();
        document.body.classList.toggle('drawer-open', drawer.open);
        if (drawer.open && search) search.open = false;
      });
    }
    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open) {
          if (drawer) drawer.open = false;
          var input = $('input[type="search"]', search);
          if (input) setTimeout(function () { input.focus(); }, 50);
        }
      });
    }
    document.addEventListener('click', function (e) {
      [search].concat($$('.facet[open]')).forEach(function (d) {
        if (d && d.open && !d.contains(e.target)) d.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      [drawer, search].concat($$('.facet[open]')).forEach(function (d) { if (d) d.open = false; });
    });
    window.addEventListener('resize', setDrawerTop);
  }

  /* ---------- Cart helpers ---------- */
  function updateCartCount() {
    return fetch(theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  var toastTimer;
  function toast(msg) {
    var el = $('#CartToast');
    if (!el) return;
    $('.toast__msg', el).textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function initAjaxCart() {
    if (!theme.ajaxCart) return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('js-product-form')) return;
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.error);
          toast(theme.strings.added);
          return updateCartCount();
        })
        .catch(function (err) { toast(err.message || theme.strings.error); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; }
        });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      var jsonEl = $('[data-product-json]', root);
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var idInput = $('[data-variant-id]', root);
      var addBtn = $('[data-add-button]', root);
      var priceEl = $('[data-price]', root);
      var sectionId = root.dataset.section;
      var productUrl = root.dataset.url;

      // Gallery
      function showMedia(id) {
        if (!id) return;
        var target = $('.product__slide[data-media-id="' + id + '"]', root);
        if (!target) return;
        $$('.product__slide', root).forEach(function (s) { s.classList.toggle('is-active', s === target); });
        $$('.product__thumb', root).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
      }
      $$('.product__thumb', root).forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
      });

      // Swipe on main image (mobile)
      var slidesWrap = $('[data-slides]', root);
      if (slidesWrap) {
        var startX = null;
        slidesWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        slidesWrap.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) < 40) return;
          var slides = $$('.product__slide', root);
          var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
          var next = slides[(idx + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
          showMedia(next.dataset.mediaId);
        });
      }

      // Quantity
      $$('[data-qty]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('.qty__input', b.parentNode);
          var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10);
          input.value = Math.max(1, v);
        });
      });

      // Variant picker
      var picker = $('[data-variant-picker]', root);
      if (!picker || !variants.length) return;

      function selectedOptions() {
        var opts = [];
        $$('fieldset', picker).forEach(function (fs, i) {
          var checked = $('input:checked', fs);
          opts[i] = checked ? checked.value : null;
        });
        return opts;
      }

      function markAvailability(opts) {
        // Grey out values that have no available variant given the other selections
        $$('fieldset', picker).forEach(function (fs, i) {
          $$('.pill', fs).forEach(function (pill) {
            var val = $('input', pill).value;
            var available = variants.some(function (v) {
              return v.available && v.options.every(function (o, j) { return j === i ? o === val : (opts[j] === null || o === opts[j]); });
            });
            pill.classList.toggle('is-unavailable', !available);
          });
        });
      }

      function onChange() {
        var opts = selectedOptions();
        opts.forEach(function (val, i) {
          var label = $('[data-selected-label="' + i + '"]', picker);
          if (label) label.textContent = val;
        });
        markAvailability(opts);
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = theme.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (productUrl) {
          var url = productUrl + '?variant=' + variant.id;
          window.history.replaceState({}, '', url);
          if (priceEl && sectionId) {
            fetch(url + '&section_id=' + sectionId)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.querySelector('[data-price]');
                if (fresh) priceEl.innerHTML = fresh.innerHTML;
              })
              .catch(function () {});
          }
        }
      }

      picker.addEventListener('change', onChange);
      markAvailability(selectedOptions());
    });
  }

  /* ---------- Modals (size guide) ---------- */
  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-modal]');
      if (opener) {
        var dlg = document.getElementById(opener.dataset.openModal);
        if (dlg && dlg.showModal) dlg.showModal();
        return;
      }
      var closer = e.target.closest('[data-close-modal]');
      if (closer) { closer.closest('dialog').close(); return; }
      if (e.target.tagName === 'DIALOG') e.target.close(); // backdrop click
    });
  }

  /* ---------- Collection filters & sort ---------- */
  function initFacets() {
    $$('.js-facets').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; // price uses Apply button
        submitFacets(form);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(form); });
    });
  }
  function submitFacets(form) {
    var params = new URLSearchParams(new FormData(form));
    // Drop empty values so URLs stay clean
    Array.from(params.keys()).forEach(function (k) {
      var vals = params.getAll(k).filter(function (v) { return v !== ''; });
      params.delete(k);
      vals.forEach(function (v) { params.append(k, v); });
    });
    window.location.search = params.toString();
  }

  /* ---------- Cart page auto-update ---------- */
  function initCartPage() {
    var form = $('#CartForm');
    if (!form) return;
    var t;
    $$('.js-cart-qty', form).forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
          form.appendChild(hidden);
          form.submit();
        }, 400);
      });
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length && el.querySelector('.product-grid')) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initHero();
    initHeader();
    initAjaxCart();
    initProduct();
    initModals();
    initFacets();
    initCartPage();
    initRecommendations();
  });

  // Re-init when sections change in the theme editor
  document.addEventListener('shopify:section:load', function () {
    initAnnouncement();
    initHero();
    initProduct();
    initFacets();
    initRecommendations();
  });
})();
